(function() {
  function LimitedTimePromotionManager(themeConfig) {
    this.themeConfig = themeConfig || {};
    this.promotionConfig = this.themeConfig.limited_time_promotion || {};
    this.isReconciling = false;
    this.pendingPromise = null;
    this.isAddingBundle = false;
    this.losAngelesFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
    this.kolkataFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
  }

  LimitedTimePromotionManager.prototype.log = function() {};

  LimitedTimePromotionManager.prototype.warn = function() {};

  LimitedTimePromotionManager.prototype.summarizeCartItems = function(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    return cart.items.map(function(item) {
      return {
        title: item.title,
        product_id: item.product_id,
        variant_id: item.variant_id,
        quantity: item.quantity,
        key: item.key,
        promo_gift: Boolean(
          Number(item.product_id) === Number(this.promotionConfig.free_gift_product_id) ||
          Number(item.variant_id) === Number(this.promotionConfig.free_gift_variant_id)
        ),
        final_price: item.final_price
      };
    }, this);
  };

  LimitedTimePromotionManager.prototype.hasRequiredSettings = function() {
    var isValid = Boolean(
      this.promotionConfig.enabled &&
      this.promotionConfig.trigger_product_id &&
      this.promotionConfig.trigger_variant_id &&
      this.promotionConfig.free_gift_variant_id
    );

    if (!isValid) {
      this.warn('Missing required settings', this.promotionConfig);
    }

    return isValid;
  };

  LimitedTimePromotionManager.prototype.toComparableDateTime = function(parts) {
    return Number(
      String(parts.year) +
        String(parts.month) +
        String(parts.day) +
        String(parts.hour) +
        String(parts.minute) +
        String(parts.second)
    );
  };

  LimitedTimePromotionManager.prototype.getTimeZoneParts = function(date, formatter) {
    var result = {
      year: '0000',
      month: '00',
      day: '00',
      hour: '00',
      minute: '00',
      second: '00'
    };

    formatter.formatToParts(date).forEach(function(part) {
      if (result[part.type] !== undefined) {
        result[part.type] = part.value;
      }
    });

    return result;
  };

  LimitedTimePromotionManager.prototype.getTimeZoneNow = function(formatter, label) {
    var parts = this.getTimeZoneParts(new Date(), formatter);

    return {
      parts: parts,
      comparable: this.toComparableDateTime(parts),
      readable:
        parts.year +
        '-' +
        parts.month +
        '-' +
        parts.day +
        ' ' +
        parts.hour +
        ':' +
        parts.minute +
        ':' +
        parts.second +
        ' ' +
        label
    };
  };

  LimitedTimePromotionManager.prototype.getLosAngelesNow = function() {
    return this.getTimeZoneNow(this.losAngelesFormatter, 'America/Los_Angeles');
  };

  LimitedTimePromotionManager.prototype.getKolkataNow = function() {
    return this.getTimeZoneNow(this.kolkataFormatter, 'Asia/Kolkata');
  };

  LimitedTimePromotionManager.prototype.parsePromotionDateTime = function(rawValue, fallbackValue) {
    var raw = typeof rawValue === 'string' ? rawValue.trim() : '';

    if (raw) {
      var match = raw.match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2})(?::(\d{2}))?(?::(\d{2}))?)?$/
      );

      if (match) {
        var parsedParts = {
          year: match[1],
          month: match[2],
          day: match[3],
          hour: match[4] || '00',
          minute: match[5] || '00',
          second: match[6] || '00'
        };

        return {
          comparable: this.toComparableDateTime(parsedParts),
          readable:
            parsedParts.year +
            '-' +
            parsedParts.month +
            '-' +
            parsedParts.day +
            ' ' +
            parsedParts.hour +
            ':' +
            parsedParts.minute +
            ':' +
            parsedParts.second +
            ' America/Los_Angeles'
        };
      }
    }

    var numericFallback = Number(fallbackValue);
    if (isNaN(numericFallback)) {
      return null;
    }

    var fallbackParts = this.getTimeZoneParts(new Date(numericFallback), this.losAngelesFormatter);

    return {
      comparable: this.toComparableDateTime(fallbackParts),
      readable:
        fallbackParts.year +
        '-' +
        fallbackParts.month +
        '-' +
        fallbackParts.day +
        ' ' +
        fallbackParts.hour +
        ':' +
        fallbackParts.minute +
        ':' +
        fallbackParts.second +
        ' America/Los_Angeles'
    };
  };

  LimitedTimePromotionManager.prototype.isPromotionActive = function() {
    var nowContext = this.getLosAngelesNow();
    var kolkataNowContext = this.getKolkataNow();
    var startAt = this.parsePromotionDateTime(
      this.promotionConfig.start_at_raw,
      this.promotionConfig.start_at
    );
    var endAt = this.parsePromotionDateTime(
      this.promotionConfig.end_at_raw,
      this.promotionConfig.end_at
    );
    var isActive = true;

    if (startAt && nowContext.comparable < startAt.comparable) {
      this.warn('Promotion inactive because Los Angeles time is before start_at', {
        now: nowContext.comparable,
        kolkata_now: kolkataNowContext.comparable,
        start_at: startAt.comparable,
        now_readable: nowContext.readable,
        kolkata_now_readable: kolkataNowContext.readable,
        start_at_readable: startAt.readable
      });
      isActive = false;
    }

    if (endAt && nowContext.comparable > endAt.comparable) {
      this.warn('Promotion inactive because Los Angeles time is after end_at', {
        now: nowContext.comparable,
        kolkata_now: kolkataNowContext.comparable,
        end_at: endAt.comparable,
        now_readable: nowContext.readable,
        kolkata_now_readable: kolkataNowContext.readable,
        end_at_readable: endAt.readable
      });
      isActive = false;
    }

    this.log('Promotion timezone debug', {
      los_angeles_now: nowContext.readable,
      los_angeles_comparable: nowContext.comparable,
      kolkata_now: kolkataNowContext.readable,
      kolkata_comparable: kolkataNowContext.comparable,
      start_at_raw: this.promotionConfig.start_at_raw,
      start_at_los_angeles: startAt && startAt.readable,
      start_at_comparable: startAt && startAt.comparable,
      end_at_raw: this.promotionConfig.end_at_raw,
      end_at_los_angeles: endAt && endAt.readable,
      end_at_comparable: endAt && endAt.comparable
    });

    this.log('Promotion window check', {
      now: nowContext.comparable,
      now_readable: nowContext.readable,
      kolkata_now_readable: kolkataNowContext.readable,
      start_at_raw: this.promotionConfig.start_at_raw,
      start_at: startAt && startAt.comparable,
      start_at_readable: startAt && startAt.readable,
      end_at_raw: this.promotionConfig.end_at_raw,
      end_at: endAt && endAt.comparable,
      end_at_readable: endAt && endAt.readable,
      active: isActive
    });

    return isActive;
  };

  LimitedTimePromotionManager.prototype.isPromotionGiftItem = function(item) {
    if (!item) return false;

    // Threshold GWP lines are owned by ajaxCart.syncGwp — never treat/remove them as LTP gifts.
    if (
      item.properties &&
      (item.properties._gwp === 'true' || item.properties._gwp === true)
    ) {
      return false;
    }

    var matchesGiftProduct =
      Number(item.product_id) === Number(this.promotionConfig.free_gift_product_id) ||
      Number(item.variant_id || item.id) === Number(this.promotionConfig.free_gift_variant_id);

    if (!matchesGiftProduct) return false;

    // Prefer explicitly tagged LTP gifts.
    if (
      item.properties &&
      (item.properties._ltp === 'true' || item.properties._ltp === true)
    ) {
      return true;
    }

    // Legacy LTP free gifts (untagged) — only $0 lines, never paid purchases of the gift SKU.
    return Number(item.final_price) === 0 || Number(item.price) === 0;
  };

  LimitedTimePromotionManager.prototype.isEligibleTriggerItem = function(item) {
    return Boolean(
      item &&
      !this.isPromotionGiftItem(item) &&
      Number(item.product_id) === Number(this.promotionConfig.trigger_product_id)
    );
  };

  LimitedTimePromotionManager.prototype.shouldShowPromotionBanner = function(cart) {
    if (!this.hasRequiredSettings() || !this.isPromotionActive()) {
      return false;
    }

    if (!cart || !Array.isArray(cart.items) || Number(cart.item_count) < 1) {
      return false;
    }

    return !cart.items.some(this.isEligibleTriggerItem.bind(this));
  };

  LimitedTimePromotionManager.prototype.updatePromotionBanner = function(cart) {
    var banners = document.querySelectorAll('[data-limited-time-promotion-banner]');

    if (!banners.length) {
      return;
    }

    var shouldShow = this.shouldShowPromotionBanner(cart);

    this.log('Updating promotion banner visibility', {
      should_show: shouldShow,
      cart_items: this.summarizeCartItems(cart)
    });

    banners.forEach(function(banner) {
      if (shouldShow) {
        banner.removeAttribute('hidden');
      } else {
        banner.setAttribute('hidden', 'hidden');
      }
    });
  };

  LimitedTimePromotionManager.prototype.updateBannerButtonState = function(isLoading) {
    var buttons = document.querySelectorAll('[data-limited-time-promotion-add]');

    if (!buttons.length) {
      return;
    }

    buttons.forEach(function(button) {
      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = button.textContent.trim();
      }

      if (isLoading) {
        button.setAttribute('disabled', 'disabled');
        button.textContent = this.themeConfig.adding_to_cart || 'Adding...';
      } else {
        button.removeAttribute('disabled');
        button.textContent = button.dataset.defaultLabel;
      }
    }, this);
  };

  LimitedTimePromotionManager.prototype.handleBannerAddToCart = function() {
    var self = this;

    if (this.isAddingBundle) {
      this.log('Banner add is already in progress');
      return;
    }

    if (!this.hasRequiredSettings() || !this.isPromotionActive()) {
      this.warn('Banner add blocked because promotion is inactive or incomplete');
      return;
    }

    this.isAddingBundle = true;
    this.updateBannerButtonState(true);
    this.log('Adding trigger product from drawer banner', {
      trigger_variant_id: this.promotionConfig.trigger_variant_id,
      free_gift_variant_id: this.promotionConfig.free_gift_variant_id
    });

    Shopify.theme.cart
      .addItem(Number(this.promotionConfig.trigger_variant_id), { quantity: 1 })
      .then(function(lineItem) {
        self.log('Trigger product added from banner', lineItem);
        return self.syncAfterTriggerAdd(lineItem);
      })
      .then(function() {
        return Shopify.theme.cart.getCart();
      })
      .then(function(cart) {
        self.log('Cart fetched after banner add', self.summarizeCartItems(cart));
        return self.reconcileCart(cart);
      })
      .then(function(result) {
        self.updatePromotionBanner(result.cart);
        return Shopify.theme.ajaxCart.updateView(self.themeConfig, result.cart);
      })
      .catch(function(error) {
        console.error('Limited time promotion banner add failed:', error);
      })
      .then(function() {
        self.isAddingBundle = false;
        self.updateBannerButtonState(false);
      });
  };

  LimitedTimePromotionManager.prototype.runOperations = function(operations) {
    var self = this;

    this.log('Running cart operations', operations);

    return operations.reduce(function(chain, operation) {
      return chain.then(function(currentCart) {
        self.log('Executing cart operation', operation);

        if (operation.type === 'add') {
          return Shopify.theme.cart
            .addItem(Number(self.promotionConfig.free_gift_variant_id), {
              quantity: 1,
              properties: { _ltp: 'true' }
            })
            .then(function() {
              return Shopify.theme.cart.getCart();
            });
        }

        if (operation.type === 'remove') {
          return Shopify.theme.cart.removeItem(operation.key);
        }

        if (operation.type === 'set_quantity') {
          return Shopify.theme.cart.updateItem(operation.key, {
            quantity: operation.quantity
          });
        }

        return currentCart;
      });
    }, Promise.resolve(null)).then(function(updatedCart) {
      if (updatedCart && updatedCart.items) {
        return updatedCart;
      }

      return Shopify.theme.cart.getCart();
    });
  };

  LimitedTimePromotionManager.prototype.reconcileCart = function(cart) {
    var self = this;

    if (!this.hasRequiredSettings() || !cart || !Array.isArray(cart.items)) {
      this.warn('Skipping reconcile because settings or cart data are incomplete', {
        has_required_settings: this.hasRequiredSettings(),
        cart: cart
      });

      return Promise.resolve({
        cart: cart,
        didMutate: false
      });
    }

    if (this.isReconciling && this.pendingPromise) {
      this.log('Reconcile already in progress, reusing pending promise');
      return this.pendingPromise;
    }

    this.isReconciling = true;
    this.pendingPromise = Promise.resolve().then(function() {
      var promotionGiftItems = cart.items.filter(function(item) {
        return self.isPromotionGiftItem(item);
      });
      var shouldHaveGift =
        self.isPromotionActive() &&
        cart.items.some(function(item) {
          return self.isEligibleTriggerItem(item);
        });
      var operations = [];

      self.log('Reconciling cart', {
        cart_items: self.summarizeCartItems(cart),
        should_have_gift: shouldHaveGift,
        promotion_gift_count: promotionGiftItems.length,
        trigger_product_id: self.promotionConfig.trigger_product_id,
        free_gift_variant_id: self.promotionConfig.free_gift_variant_id
      });

      if (!shouldHaveGift) {
        promotionGiftItems.forEach(function(item) {
          operations.push({
            type: 'remove',
            key: item.key
          });
        });
      } else if (!promotionGiftItems.length) {
        operations.push({
          type: 'add'
        });
      } else {
        if (promotionGiftItems[0].quantity !== 1) {
          operations.push({
            type: 'set_quantity',
            key: promotionGiftItems[0].key,
            quantity: 1
          });
        }

        promotionGiftItems.slice(1).forEach(function(item) {
          operations.push({
            type: 'remove',
            key: item.key
          });
        });
      }

      if (!operations.length) {
        self.log('No cart changes needed');
        return {
          cart: cart,
          didMutate: false
        };
      }

      return self.runOperations(operations).then(function(updatedCart) {
        return {
          cart: updatedCart,
          didMutate: true
        };
      });
    }).catch(function(error) {
      console.error('Limited time promotion sync failed:', error);

      return {
        cart: cart,
        didMutate: false
      };
    }).then(function(result) {
      self.isReconciling = false;
      self.pendingPromise = null;

      return result;
    });

    return this.pendingPromise;
  };

  LimitedTimePromotionManager.prototype.syncAfterTriggerAdd = function(lineItem) {
    var self = this;

    this.log('Product added from form', lineItem);

    if (
      !this.hasRequiredSettings() ||
      !this.isPromotionActive() ||
      !lineItem ||
      this.isPromotionGiftItem(lineItem) ||
      Number(lineItem.product_id) !== Number(this.promotionConfig.trigger_product_id)
    ) {
      this.log('Skipping promo sync after add', {
        has_required_settings: this.hasRequiredSettings(),
        is_active: this.isPromotionActive(),
        has_line_item: Boolean(lineItem),
        is_promo_gift: this.isPromotionGiftItem(lineItem),
        line_item_product_id: lineItem && lineItem.product_id,
        trigger_product_id: this.promotionConfig.trigger_product_id
      });

      return Promise.resolve(lineItem);
    }

    this.log('Trigger product matched, syncing promotion gift');

    return Shopify.theme.cart.getCart().then(function(cart) {
      self.log('Cart fetched after trigger add', self.summarizeCartItems(cart));
      return self.reconcileCart(cart);
    }).then(function() {
      return lineItem;
    }).catch(function(error) {
      console.error('Limited time promotion add sync failed:', error);
      return lineItem;
    });
  };

  LimitedTimePromotionManager.prototype.installHooks = function() {
    var self = this;
    var originalUpdateView = Shopify.theme.ajaxCart.updateView;
    var originalUpdateCheck = Shopify.theme.ajaxCart.updateCheck;
    var originalAddItemFromForm = Shopify.theme.cart.addItemFromForm;

    if (Shopify.theme.ajaxCart._limitedTimePromotionHooked) {
      return;
    }

    Shopify.theme.ajaxCart._limitedTimePromotionHooked = true;
    this.log('Installing AJAX cart hooks');

    Shopify.theme.ajaxCart.updateView = function(config, cart, viewOptions) {
      var context = this;
      viewOptions = viewOptions || {};

      function renderCart(resultCart) {
        return Promise.resolve(originalUpdateView.call(context, config, resultCart, viewOptions)).then(function() {
          self.updatePromotionBanner(resultCart);
        });
      }

      if (viewOptions.skipPromotionReconcile) {
        // GWP owns this pass — only refresh the banner. Do not reconcile/remove gifts here
        // (that was removing threshold GWP lines a moment after they were added).
        return Promise.resolve(originalUpdateView.call(context, config, cart, viewOptions)).then(function() {
          if (typeof Shopify === 'undefined' || !Shopify.theme || !Shopify.theme.cart) {
            return;
          }
          return Shopify.theme.cart.getCart().then(function(freshCart) {
            self.updatePromotionBanner(freshCart);
          });
        });
      }

      self.log('Intercepted ajaxCart.updateView', {
        item_count: cart && cart.item_count,
        cart_items: self.summarizeCartItems(cart)
      });

      return self.reconcileCart(cart).then(function(result) {
        return renderCart(result.cart);
      });
    };

    Shopify.theme.ajaxCart.updateCheck = function(config, cart, viewOptions) {
      var context = this;
      viewOptions = viewOptions || {};

      self.log('Intercepted ajaxCart.updateCheck', {
        item_count: cart && cart.item_count,
        cart_items: self.summarizeCartItems(cart)
      });

      return self.reconcileCart(cart).then(function(result) {
        return Promise.resolve(originalUpdateCheck.call(context, config, result.cart, viewOptions)).then(function() {
          self.updatePromotionBanner(result.cart);
        });
      });
    };

    Shopify.theme.cart.addItemFromForm = function(form) {
      return originalAddItemFromForm.call(this, form).then(function(lineItem) {
        return self.syncAfterTriggerAdd(lineItem);
      });
    };

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-limited-time-promotion-add]');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      self.handleBannerAddToCart();
    });
  };

  function getThemeConfig() {
    var configElement = document.getElementById('cart-config');

    if (!configElement) {
      return null;
    }

    try {
      return JSON.parse(configElement.textContent || '{}');
    } catch (error) {
      console.error('Unable to parse cart config:', error);
      return null;
    }
  }

  function initLimitedTimePromotion(attempt) {
    var themeConfig = getThemeConfig();

    if (
      !themeConfig ||
      !window.Shopify ||
      !Shopify.theme ||
      !Shopify.theme.cart ||
      !Shopify.theme.ajaxCart
    ) {
      if (attempt < 20) {
        window.setTimeout(function() {
          initLimitedTimePromotion(attempt + 1);
        }, 200);
      }

      return;
    }

    var manager = new LimitedTimePromotionManager(themeConfig);
    manager.log('Manager created', manager.promotionConfig);

    if (!manager.hasRequiredSettings()) {
      manager.warn('Aborting init because promotion settings are incomplete');
      return;
    }

    manager.installHooks();

    // Reconcile stale carts on load so expired or missing promo gifts self-heal.
    Shopify.theme.cart.getCart().then(function(cart) {
      manager.log('Initial cart fetched on boot', manager.summarizeCartItems(cart));
      return manager.reconcileCart(cart);
    }).then(function(result) {
      manager.updatePromotionBanner(result.cart);

      if (result.didMutate) {
        manager.log('Boot reconcile changed cart, forcing view refresh');
        Shopify.theme.ajaxCart.updateView(themeConfig, result.cart);
      } else {
        manager.log('Boot reconcile made no changes');
      }
    }).catch(function(error) {
      console.error('Limited time promotion boot sync failed:', error);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    window.setTimeout(function() {
      initLimitedTimePromotion(0);
    }, 800);
  });
})();
